const names = {
  en: [
    'Su',
    'Mo',
    'Tu',
    'We',
    'Th',
    'Fr',
    'Sa'
  ],
  de: [
    'So',
    'Mo',
    'Di',
    'Mi',
    'Do',
    'Fr',
    'Sa'
  ]
}

/**
 * Get short weekday names
 * @param {'en'|'de'} language Language code
 * @returns {string[]} Short weekday names
 */
export default function (language) {
  return names[language]
}
